//import './App.css';

import { createContext, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import Register from './Register';
import { WebSocketProvider } from './app/ws/WebSocketProvider';
import Layout from './components/Layout';
import PublicLayout from './components/PublicLayout';
import Company from './components/dashboard/Company';
import DashboardTest from './components/dashboard/DashboardTest';
import DashboardHome from './components/dashboard/Home';
import MyCompanies from './components/dashboard/MyCompanies';
import Login from './features/auth/Login';
import RequireAuth from './features/auth/RequireAuth';
import RequireCriticalAuth from './features/auth/RequireCriticalAuth';
import RestorePassword from './features/core/accountUtility/RestorePassword';
import BusinessUnit from './features/core/businessUnit/BusinessUnitDetail';
import BusinessUnits from './features/core/businessUnit/BusinessUnits';
import EditBusinessUnit from './features/core/businessUnit/EditBusinessUnit';
import NewBusinessUnit from './features/core/businessUnit/NewBusinessUnit';
import CompanyDetail from './features/core/company/CompanyDetail';
import EditCompany from './features/core/company/EditCompany';
import CompanyRoles from './features/core/companyRoles/CompanyRoles';
import RoleEdit from './features/core/companyRoles/RoleEdit';
import EditEmployment from './features/core/employment/EditEmployee';
import EmployeeDetail from './features/core/employment/EmployeeDetail';
import ManageEmployees from './features/core/employment/ManageEmployees';
import NewEmployment from './features/core/employment/NewEmployment';
import Home from './features/core/home/Home';
import LicenseAlert from './features/core/license/LicenseAlert';
import LicenseInfo from './features/core/license/LicenseInfo';
import CompanyLog from './features/core/log/CompanyLog';
import UserLog from './features/core/log/UserLog';
import GlobalMap from './features/core/map/GlobalMap';
import Notifications from './features/core/notification/Notifications';
import EditUserInfo from './features/core/userInfo/EditUserInfo';
import UserInfo from './features/core/userInfo/UserInfo';
import Users from './features/core/users/Users';
import UsersList from './features/core/users/UsersList';
import AbsenceDashboard from './features/hr/absenceReport/AbsenceDashboard';
import AbsenceManageRequests from './features/hr/absenceReport/AbsenceManageRequests';
import AbsenceReport from './features/hr/absenceReport/AbsenceReport';
import AbsenceSettings from './features/hr/absenceReport/AbsenceSettings';
import MyAbsence from './features/hr/absenceReport/MyAbsence';
import CostRefundDetail from './features/hr/costRefund/CostRefundDetail';
import CostRefundEdit from './features/hr/costRefund/CostRefundEdit';
import CostRefunds from './features/hr/costRefund/CostRefunds';
import MyCostRefunds from './features/hr/costRefund/MyCostRefuns';
import MyOvertimes from './features/hr/overtime/MyOvertimes';
import Overtimes from './features/hr/overtime/Overtimes';
import ManageContractModel from './features/hr/workContract/ManageContract.Model';
import WorkerLeaveLeft from './features/hr/workContract/WorkerLeaveLeft';
import PlatformAdmin from './features/platformAdmin/PlatformAdmin';
import SandBox from './features/test/SandBox';
import MyWhistles from './features/whistle/MyWhistles';
import WhistleManage from './features/whistle/WhistleManage';
import PrivacyPolicy from 'features/core/privacy/PrivacyPolicy';
import PrivacyPolicyEditor from 'features/core/privacy/PrivacyPolicyEditor';
import HrSettings from 'features/hr/settings/HrSettings';
import MainSettings from 'features/core/settings/MainSettings';
import HealthDashboard from 'features/health/dashboard/HealthDashboard';
import DeviceDashboard from 'features/device/dashboard/DeviceDashboard';
import HealthProfiles from 'features/health/profiles/HealthProfiles';
import HealthPatients from 'features/health/patients/HealthPatients';
import HealthHistory from 'features/health/history/HealthHistory';
import HealthSettings from 'features/health/settings/HealthSettings';
import HealthEvent from 'features/health/events/HealthEvents';
import SafetyDashboard from 'features/safety/dashboard/SafetyDashboard';
import SafetySettings from 'features/safety/settings/SafetySettings';
import { SafetyAlarmProvider } from 'features/safety/SafetyAlarmProvider';
import EmergencyBanner from 'features/safety/EmergencyBanner';
import SafetyStats from 'features/safety/stats/SafetyStats';
import RolePermissionsPage from 'features/core/companyRoles/RolePermissionsPage';
import DevicesSettings from 'features/device/settings/DevicesSettings';
import HealthDebugTool from 'features/health/debug/HealthDebugTool';


// CONTEXT
export const AppContext = createContext(null);



function App() {
  // DATA HOLD
  const [globalCounter, setGlobalCounter] = useState(0);

  console.log("App refresh")

  return (
    <AppContext.Provider value={{ globalCounter, setGlobalCounter }}>
      {/* <Connector mqttProps="ws://localhost:8000/mqtt"> */}

      <WebSocketProvider>
        {/* <SessionMonitor /> */}

        <Routes>

          <Route path="/" element={<PublicLayout />}>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/restore-password" element={<RestorePassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/test" element={<DashboardTest />} />
            <Route path="/license/expired" element={<LicenseAlert />} />
          </Route>

          <Route path="/dashboard" element={<RequireCriticalAuth />}>
            <Route path="/dashboard/license" element={<Layout />}>
              <Route path="/dashboard/license" element={<LicenseInfo />} />
            </Route>
          </Route>

          <Route path="/dashboard" element={<RequireAuth />}>
            <Route path="/dashboard"
              element={<SafetyAlarmProvider>
                <EmergencyBanner />
                <Layout />
              </SafetyAlarmProvider>
              }>




              <Route path="/dashboard/main/settings" element={<MainSettings />} />
              <Route path="/dashboard/home" element={<Home />} />
              <Route path="/dashboard/userslist" element={<UsersList />} />
              <Route path="/dashboard/auz" element={<DashboardHome />} />

              <Route path="/dashboard/companies" element={<MyCompanies />} />
              <Route path="/dashboard/company/:id" element={<Company />} />
              <Route path="/dashboard/company" element={<CompanyDetail />} />
              <Route path="/dashboard/company/edit" element={<EditCompany />} />

              <Route path="/dashboard/businessUnits" element={<BusinessUnits />} />
              <Route path="/dashboard/businessUnits/detail" element={<BusinessUnit />} />
              <Route path="/dashboard/businessUnits/new" element={<NewBusinessUnit />} />
              <Route path="/dashboard/businessUnits/edit" element={<EditBusinessUnit />} />

              <Route path="/dashboard/employees" element={<ManageEmployees />} />
              <Route path="/dashboard/employees/new-employment" element={<NewEmployment />} />
              <Route path="/dashboard/employees/see-employment" element={<EmployeeDetail />} />
              <Route path="/dashboard/employees/edit-employment" element={<EditEmployment />} />
              <Route path="/dashboard/roles" element={<RolePermissionsPage />} />
              <Route path="/dashboard/roles/edit" element={<RoleEdit />} />


              <Route path="/dashboard/map" element={<GlobalMap />} />
              <Route path="/dashboard/notifications" element={<Notifications />} />
              <Route path="/dashboard/privacy" element={<PrivacyPolicy />} />
              <Route path="/dashboard/privacy/editor" element={<PrivacyPolicyEditor />} />
              <Route path="/dashboard/users" element={<Users />} />
              <Route path="/dashboard/log" element={<CompanyLog />} />

              <Route path="/dashboard/userInfo" element={<UserInfo />} />
              <Route path="/dashboard/userInfo/edit" element={<EditUserInfo />} />
              <Route path="/dashboard/myLog" element={<UserLog />} />

              {/* HR  */}
              <Route path="/dashboard/absences/settings" element={<HrSettings />} />
              <Route path="/dashboard/absences/dashboard" element={<AbsenceDashboard />} />
              <Route path="/dashboard/absences/manage" element={<AbsenceManageRequests />} />
              <Route path="/dashboard/absences/report" element={<AbsenceReport />} />
              <Route path="/dashboard/absences/settings" element={<AbsenceSettings />} />
              <Route path="/dashboard/absences/my" element={<MyAbsence />} />

              <Route path="/dashboard/overtimes" element={<Overtimes />} />
              <Route path="/dashboard/overtimes/my" element={<MyOvertimes />} />

              <Route path="/dashboard/costRefunds" element={<CostRefunds />} />
              <Route path="/dashboard/costRefunds/detail" element={<CostRefundDetail administrable={true} />} />
              <Route path="/dashboard/costRefunds/my" element={<MyCostRefunds />} />
              <Route path="/dashboard/costRefunds/my/detail" element={<CostRefundDetail />} />
              <Route path="/dashboard/costRefunds/my/edit" element={<CostRefundEdit />} />

              <Route path="/dashboard/whistle/dashboard" element={<WhistleManage />} />
              <Route path="/dashboard/whistle/my" element={<MyWhistles />} />

              <Route path="/dashboard/sandbox" element={<SandBox />} />

              <Route path="/dashboard/work-contract/models" element={<ManageContractModel />} />
              <Route path="/dashboard/work-contract/workers" element={<WorkerLeaveLeft />} />

              {/* ADMIN  */}
              <Route path="/dashboard/admin/companies" element={<PlatformAdmin />} />

              {/* Health  */}
              <Route path="/dashboard/health/settings" element={<HealthSettings />} />
              <Route path="/dashboard/health/dashboard" element={<HealthDashboard />} />
              <Route path="/dashboard/health/events" element={<HealthEvent />} />
              <Route path="/dashboard/health/history" element={<HealthHistory />} />
              <Route path="/dashboard/health/history/my" element={<HealthHistory privateOnly={true} />} />
              <Route path="/dashboard/health/profiles" element={<HealthProfiles />} />
              <Route path="/dashboard/health/patients" element={<HealthPatients />} />
              <Route path="/dashboard/health/debug" element={<HealthDebugTool />} />

              {/* Safety  */}
              <Route path="/dashboard/safety/settings" element={< SafetySettings />} />
              <Route path="/dashboard/safety/dashboard" element={< SafetyDashboard />} />
              <Route path="/dashboard/safety/stats" element={< SafetyStats />} />

              {/* Devices  */}
              <Route path="/dashboard/devices/settings" element={< DevicesSettings />} />
              <Route path="/dashboard/devices/dashboard" element={<DeviceDashboard />} />

            </Route>
          </Route>
        </Routes>
      </WebSocketProvider>
      {/* </Connector> */}
    </AppContext.Provider>
  );
}

export default App;
